export default "__VITE_ASSET__DlDxbai8__"